import * as a1lib from "alt1/base";
import DialogReader, { DialogButton } from "alt1/dialog";
import { OldDom } from "@runeapps/common/oldlib";
import { ImgRef } from "alt1/base";

var reader = new DialogReader();

let elid = OldDom.id;

type Score = "Terrible" | "Bad" | "Neutral" | "Good" | "Excellent";
let answerprom = fetch("./answers.json").then(r => r.json()).then(r => r as { t: string, score: Score }[]);

start();
function start() {
	a1lib.identifyApp("./appconfig.json");
	a1lib.PasteInput.listen(solve, e => elid("output").innerText = e);
	window.addEventListener("blur", blur);
	window.addEventListener("focus", focus);
	if (!window.alt1) {
		elid("solvepaste").style.display = "block";
		elid("unlockbutton").style.display = "none";
		if (!document.hasFocus()) { blur(); }
		elid("output").innerText = "Paste a screenshot with the answer options visible.";
	} else {
		a1lib.on("alt1pressed", e => {
			elid("unlockbutton").classList.add("fakeactive");
			setTimeout(function () { solve(); elid("unlockbutton").classList.remove("fakeactive"); }, 50);
		});
	}
}

function focus() {
	elid("solvepaste").classList.remove("blur");
}

function blur() {
	if (document.hasFocus()) { return; }
	elid("solvepaste").classList.add("blur");
}

function strcompare(first: string, second: string) {
	// Calculates the similarity between two strings  
	// discuss at: http://phpjs.org/functions/similar_text
	first += '';
	second += '';
	var pos1 = 0,
		pos2 = 0,
		max = 0,
		firstLength = first.length,
		secondLength = second.length,
		p, q, l, sum;
	max = 0;
	for (p = 0; p < firstLength; p++) {
		for (q = 0; q < secondLength; q++) {
			for (l = 0;
				(p + l < firstLength) && (q + l < secondLength) && (first.charAt(p + l) === second.charAt(q + l)); l++);
			if (l > max) {
				max = l;
				pos1 = p;
				pos2 = q;
			}
		}
	}
	sum = max;
	if (sum) {
		if (pos1 && pos2) {
			sum += strcompare(first.substr(0, pos2), second.substr(0, pos2));
		}
		if ((pos1 + max < firstLength) && (pos2 + max < secondLength)) {
			sum += strcompare(first.substr(pos1 + max, firstLength - pos1 - max), second.substr(pos2 + max, secondLength - pos2 - max));
		}
	}
	return sum;
}

function strcomparescore(foundstring: string, templatestr: string) {
	return (strcompare(foundstring.toLowerCase(), templatestr.toLowerCase()) - Math.abs(foundstring.length - templatestr.length) / 2) / foundstring.length;
}

export async function solve(img?: ImgRef) {
	var scores = ["Terrible", "Bad", "Neutral", "Good", "Excellent"];
	var answers = await answerprom;

	if (!img) {
		try { img = a1lib.captureHoldFullRs(); } catch (e) { }
	}
	if (!img) {
		elid("output").innerText = "Need pixel permission.";
		return;
	}

	var pos = reader.find(img);
	if (!pos) {
		elid("output").innerText = "Chat options not found, click the button when you have to select an answer in-game.";
		return;
	}
	var box = reader.read(img);
	if (!box) {
		elid("output").innerText = "Failed to read dialog box.";
		return;
	}
	if (!box.opts) {
		elid("output").innerText = "Click this button again when the chat choices are shown.";
		return;
	}
	var opts = box.opts;


	let bestans: DialogButton | null = null;
	let bestansscore = -1;
	for (let a in opts) {

		let bestscore = 0;
		let best: typeof answers[number] = null!;
		for (let b in answers) {
			let c = strcomparescore(opts[a].text, answers[b].t);
			if (c > bestscore) {
				bestscore = c;
				best = answers[b];
			}
		}
		let c = scores.indexOf(best.score);
		if (c > bestansscore) {
			bestansscore = c;
			bestans = opts[a];
		}
	}

	var frag = OldDom.frag();
	for (let a in opts) {
		frag.appendChild(OldDom.div("chatopt" + (opts[a] == bestans ? " selected" : ""), [opts[a].text]));
	}
	OldDom.put("output", frag);
	if (window.alt1 && alt1.permissionOverlay && bestans) {
		alt1.overLayRect(a1lib.mixColor(0, 255, 0), bestans.buttonx, bestans.y - 6, bestans.width, 14, 3000, 3);
	}
}
